export const reduxKey = '@@addToGroups';
export const actionKey = '@@addToGroups';

export const groupFoldersStreamType = '@@groupfolders';
export const groupsStreamType = '@@groups';
export const recommendedGroupsStreamType = '@@recommendedGroups';

export const recommendedGroupsStreamId = 'ADD_TO_GROUPS_PANEL_RECOMMENDED_GROUPS';
